<div mat-dialog-title>
  {{ modalData.title }}
  <div style="float: right; margin-top: -5px;">

    <button mat-icon-button [mat-dialog-close]="true" (click)="closeModal()">
      <img src="../../../../assets/close-white.png" style="width: 12px;">
    </button>
  </div>
</div>

<mat-dialog-content class="mat-typography">
  <!-- <mat-spinner *ngIf="isLoading" class="spinner-center" diameter="40" style="z-index: 1000;"></mat-spinner> -->
  <div class="row d-flex justify-content-center">
    <div class="col-12 p-3">
      <p style="font-size: medium;" class="text-center lifedi-color">เลือกวันที่</p>
      <div class="row d-flex justify-content-center">
        <!-- <label class="col-2 col-form-label">
          วันที่ทำรายการ
        </label> -->
        <form [formGroup]="paymentDateForm">
          <div class="d-flex justify-content-center">
            <div class="col-12">
              <input class="form-control text-center" formControlName="paymentDate" date-format="dd-MM-yyyy HH:mm:ss"
                [selectMode]="'range'" style="width: 100%;" [owlDateTimeTrigger]="dtPicker" [owlDateTime]="dtPicker"
                [rangeSeparator]="'-'" dateFormat="dd-MM-yyyy" autocomplete="off">
              <owl-date-time #dtPicker [pickerType]="'calendar'"></owl-date-time>
              <p class="text-center text-info mt-4">*กรณีเลือกวันเดียว เลือกวันนั้นสองครั้ง</p>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</mat-dialog-content>

<div *ngIf="modalData.isEdit" align="center" style="padding-bottom: 20px; padding-top: 20px;">
  <button mat-button class="m-3" style="background: #3E8C1A; color: #fff;" (click)="confirm()"
    [disabled]="!paymentDateForm.valid">
    {{ modalData.actionBtnText }}
  </button>
  <button mat-button class="m-3" style="background: #c0c0c0; color: #fff;" (click)="closeModal()">
    {{ modalData.cancleBtnText }}
  </button>
</div>
